import React from 'react';

export const HelQuestionBlack = (props: any) => (
  <svg {...props} width="18" height="18" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="prefix__a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g filter="url(#prefix__a)" transform="translate(-435 -2411)" fillRule="evenodd">
      <path
        d="M444 2411.53c-4.67 0-8.47 3.8-8.47 8.47 0 4.67 3.8 8.47 8.47 8.47 4.67 0 8.47-3.8 8.47-8.47 0-4.67-3.8-8.47-8.47-8.47zm-.353 13.411a1.06 1.06 0 110-2.118 1.06 1.06 0 010 2.118zm3.043-6.263c-.218.35-.632.742-1.244 1.178-.989.731-.962.894-.962 1.556h-1.734c0-.518-.011-.915.268-1.399.179-.31.506-.64.982-.988.571-.408 1.126-.801 1.126-1.486 0-.641-.55-.87-1.19-.87-.655 0-1.401.214-2.24.642l-.713-1.433c1.523-.854 3.925-1.24 5.24-.17.963.785.969 2.167.467 2.97z"
        fill="#5B2F91"
      />
    </g>
  </svg>
);
